import { httpDelete, patch, post } from '../../utils/http';

export const addUniform = ({ accountId, branchId, uniform }) =>
  post(`/accounts/${accountId}/branches/${branchId}/uniforms`, uniform);

export const updateUniform = ({ accountId, branchId, uniformId, uniform }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/uniforms/${uniformId}`, uniform);

export const deleteUniform = ({ accountId, branchId, uniformId }) =>
  httpDelete(`/accounts/${accountId}/branches/${branchId}/uniforms/${uniformId}`);
